export enum Entities {
  ApiConnections = 'ApiConnections',
  ExpandedDocumentView = 'ExpandedDocumentView',
  Documents = 'Documents',
  Companies = 'Companies',
  DocumentStatuses = 'DocumentStatuses',
  DocumentComments = 'DocumentComments',
  SiteSections = 'SiteSections',
  Projects = 'Projects',
  ProjectInvitations = 'ProjectInvitations',
  TargetKeywords = 'TargetKeywords',
  CmsPost = 'CmsPost',
  CmsConnections = 'CmsConnections',
  CmsCategories = 'CmsCategories',
  SocialAccounts = 'SocialAccounts',
  SocialSubAccounts = 'SocialSubAccounts',
  Themes = 'Themes',
  PromptFlows = 'PromptFlows',
  ContentGraph = 'ContentGraph',
  IngestSitemap = 'IngestSitemap',
  BatchJobs = 'BatchJobs',
  Subscriptions = 'Subscriptions'
}

export enum EntityName {
  ApiConnection = 'ApiConnection',
  ExpandedDocumentView = 'ExpandedDocumentView',
  Document = 'Document',
  Company = 'Company',
  DocumentStatus = 'DocumentStatus',
  DocumentComment = 'DocumentComment',
  SiteSection = 'SiteSection',
  Project = 'Project',
  ProjectInvitation = 'ProjectInvitation',
  TargetKeyword = 'TargetKeyword',
  CmsPost = 'CmsPost',
  CmsConnection = 'CmsConnection',
  CmsCategory = 'CmsCategory',
  SocialAccount = 'SocialAccount',
  SocialSubAccount = 'SocialSubAccount',
  Theme = 'Theme',
  PromptFlow = 'PromptFlow',
  Subscription = 'Subscription'
}
